import { appendSearch } from './appendSearch.js';
import { FTUE_PORTFOLIOS_TOOLTIP_PARAMETER } from '@/components/PlatformSidebar/components/FTUETooltips/constants.js';
import { ParsedQuery } from '@/types/parsedQuery.js';
import getConfig from 'next/config';
import { type UrlObject } from 'node:url';

const { publicRuntimeConfig } = getConfig();

// eslint-disable-next-line complexity
export const getRelativeProfileHref = ({
  displayUsername,
  href,
  isPlaywright,
  query,
}: {
  displayUsername: string;
  href: UrlObject | string;
  isPlaywright: boolean;
  query?: ParsedQuery;
}): UrlObject | string => {
  const isReviewApp = publicRuntimeConfig.isReviewApp === 'true';
  const allowUsernamePath = isReviewApp || isPlaywright;

  const sanitizedParameters = {
    debugPanel: query?.['debugPanel'] ?? undefined,
    fromEditor: query?.['fromEditor'] ?? undefined,
    [FTUE_PORTFOLIOS_TOOLTIP_PARAMETER]: query?.['portfolioGuide'] ?? undefined,
    grid: query?.['debugGrid'] ?? undefined,
    hideTools: query?.['hideTools'] ?? undefined,
    isMockPreview: query?.['isMockPreview'] ?? undefined,
    isMockPreviewingEnabled: query?.['isMockPreview'] ?? undefined,
    openCustomizationSidebarScreen:
      query?.['openCustomizationSidebarScreen'] ?? undefined,
    openThemePicker: query?.['openThemePicker'] ?? undefined,
    proModal: query?.['proModal'] ?? undefined,
    referralIntentId: query?.['referralIntentId'] ?? undefined,
    styleOverride: query?.['styleOverride'] ?? undefined,
  };

  if (typeof href === 'string') {
    const resolvedHref = allowUsernamePath
      ? `/${displayUsername}${href}`
      : href;
    const withoutHash = resolvedHref.replace(/#\w*/u, '');
    const withSearch = appendSearch(withoutHash, sanitizedParameters);
    const hash = /#\w*/u.exec(resolvedHref)?.[0] ?? '';
    return `${withSearch}${hash}`;
  }

  if ('href' in href) {
    const resolvedHref = allowUsernamePath
      ? `/${displayUsername}${href.href}`
      : href.href ?? '';
    const withoutHash = resolvedHref.replace(/#\w*/u, '');
    const withSearch = appendSearch(withoutHash, sanitizedParameters);
    const hash = /#\w*/u.exec(resolvedHref)?.[0] ?? '';

    href.href = `${withSearch}${hash}`;
    return href;
  }

  return href;
};
